/*
 * @Descripttion: 
 * @version: 
 * @Author: bbq
 * @Date: 2020-10-10 09:56:58
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-02-08 15:33:27
 */
import React, { Component } from 'react';
import { PubSub } from '@platform/api';
import executeAutoFocus from './executeAutoFocus';

const { matchItemFocus } = executeAutoFocus;

function SearchWithAutoFocus(WrappedComponent) {
    return class WithAutoFocus extends Component {
        state = { isPass: true }

        componentDidMount() {
            let { areaId, name, uniqueKey, status: renderStatus } = this.props;
            this.searchRequiredToken = PubSub.subscribe('searchRequired_' + areaId, (msg, dataObj) => {
                let { moduleId, data, status } = dataObj || {};
                if (moduleId !== areaId) { return; }
                let selector = '';
                let prefix = status === 'simple' ? '#hot-key-' : '#hot-key-modal-';
                if (Array.isArray(data) && data.includes(name)) {
                    // 如果没有获取到对应的itemtype 就统一用normal来处理， 如果碰到特殊的就在往matchItemFocus里加
                    renderStatus === status && this.setState({ isPass: false });
                    if (name === data[0]) {
                        selector = `${areaId ? (prefix + areaId) : ''}.search-${uniqueKey} [hotkeytag="searchArea-${data[0]}"]`;
                        // console.log(selector);
                        matchItemFocus[this.props.itemtype] === undefined
                            ? matchItemFocus['normal'](selector)
                            : matchItemFocus[this.props.itemtype](selector);
                    }
                } else if (data === name) {
                    renderStatus === status && this.setState({ isPass: false });
                    selector = `${areaId ? (prefix + areaId) : ''}.search-${uniqueKey} [hotkeytag="searchArea-${data}"]`;
                    // console.log(selector);
                    matchItemFocus[this.props.itemtype] === undefined
                        ? matchItemFocus['normal'](selector)
                        : matchItemFocus[this.props.itemtype](selector);
                }
            });
            this.clearWarningToken = PubSub.subscribe('clearWarning_' + areaId, (msg, dataObj) => {
                let { moduleId, data, status } = dataObj || {};
                if (moduleId !== areaId || this.state.isPass) { return; }
                if (Array.isArray(data) && data.includes(name)) {
                    renderStatus === status && this.setState({ isPass: true });
                } else if (name == data) {
                    renderStatus === status && this.setState({ isPass: true });
                }
            });
        }

        componentWillUnmount() {
            this.searchRequiredToken && PubSub.unsubscribe(this.searchRequiredToken);
            this.clearWarningToken && PubSub.unsubscribe(this.clearWarningToken);
            this.dom = null;
        }

        render() {
            return (
                <WrappedComponent
                    ref={dom => {
                        this.dom = dom;
                    }}
                    {...this.props}
                    isPass={this.state.isPass}
                />
            );
        }
    };
}

export default SearchWithAutoFocus;